// SF4 — where on Amazon the money converts, and whether the adjustment points
// it the right way.
import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import s from '../AdsAnalytics.module.css';
import { money, pct, ratio } from '../format';

export default function Placements({ data, loading }) {
  if (loading && !data) return <div className={s.empty}>Loading…</div>;
  if (!data) return null;
  if (!data.account?.length) {
    return (
      <div className={s.empty}>
        <p>No placement rows in this period.</p>
        <p className={s.hint}>{data.note}</p>
      </div>
    );
  }
  const currency = data.currency;
  return (
    <>
      <div className={s.tileRow}>
        {data.account.map((p) => (
          <div key={p.placement} className={s.tile}>
            <span className={s.tileLabel}>{p.label}</span>
            <span className={s.tileValue}>{ratio(p.acos, p.acos_reason)}</span>
            <span className={s.tileNote}>
              {money(p.spend, currency)} · {pct(p.spend_share)} of spend · CVR{' '}
              {ratio(p.cvr, p.cvr_reason, 1)}
            </span>
          </div>
        ))}
      </div>

      <h4 className={s.sectionTitle} style={{ marginTop: 20 }}>By campaign</h4>
      {data.campaigns.map((c) => (
        <section key={c.campaign_id} className={s.block}>
          <div className={s.blockHead}>
            <span className={s.blockAsin}>{c.campaign_name || c.campaign_id}</span>
            {c.adjustment_wrong_way && (
              <span className={s.flag}>
                <FiAlertTriangle /> adjustment pointing the wrong way: {c.flagged.join(', ')}
              </span>
            )}
          </div>
          <table className={s.subTable}>
            <thead>
              <tr>
                <th>Placement</th><th className={s.right}>Spend</th>
                <th className={s.right}>ACOS</th><th className={s.right}>CVR</th>
                <th className={s.right}>Adjustment</th>
              </tr>
            </thead>
            <tbody>
              {c.placements.map((p) => (
                <tr key={p.placement}>
                  <td>{p.label}</td>
                  <td className={s.right}>{money(p.spend, currency)}</td>
                  <td className={s.right}>
                    <span className={p.above_target ? s.down : undefined}>
                      {ratio(p.acos, p.acos_reason)}
                    </span>
                  </td>
                  <td className={s.right}>{ratio(p.cvr, p.cvr_reason, 1)}</td>
                  <td className={s.right}>
                    {p.adjustment == null
                      ? <span className={s.unknown}>none set</span>
                      : `+${p.adjustment}%`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ))}
      <p className={s.hint} style={{ marginTop: 10 }}>
        A placement is flagged when the campaign boosts it while it runs above your target —
        that points the money the wrong way. Boosting one that runs well is not flagged.
        {' '}{data.note}
      </p>
    </>
  );
}
